import { render, staticRenderFns } from "./vueBreadcrumbs.vue?vue&type=template&id=2c5cc9a2&scoped=true&"
import script from "./vueBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./vueBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./vueBreadcrumbs.vue?vue&type=style&index=0&id=2c5cc9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5cc9a2",
  null
  
)

export default component.exports